import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import Header from "./Header";
import Map from "./Map";
import SearchResult from "./SearchResult";

const render = (status) => {
  if (status === Status.FAILURE) return <h3>{status}</h3>;
  return <h3>{status}</h3>;
};

const previaAPI = "AIzaSyAAjQhPipc94BAycRjPA6B5d5jHxrp-SUA";

function SearchOfficeView({hideshowmypositionlink}) {
  const [zoom, setZoom] = React.useState(4);
  const [center, setCenter] = React.useState({
    lat: 63,
    lng: 16,
  });

  const onIdle = (m) => {
    setZoom(m.getZoom());
    setCenter(m.getCenter().toJSON());
  };

  return (
    <>
      <Header />
      <Wrapper apiKey={previaAPI} render={render}>
        <Map
          center={center}
          zoom={zoom}
          onIdle={onIdle}
          fullscreenControl={false}
          streetViewControl={false}
          mapTypeControl={false}
          hideshowmypositionlink={hideshowmypositionlink}
        />
      </Wrapper>
      <SearchResult />
    </>
  );
}

export default SearchOfficeView;
